import ReelListLayout from "@/features/reels/layout";

export default ReelListLayout;